import React from "react";
import Header from "../../../../components/Header/Header";
import {lang, language} from "../../../../const/language";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "reactstrap/es/Container";
import {GiStickFrame} from "react-icons/all";
import Card from "reactstrap/lib/Card";
import CardBody from "reactstrap/es/CardBody";
import './getComment.scss'
import pdfView from '../../../../assets/img/common/defaultPDF.jpg'

class getComment extends React.Component {
    state = {
        randomLoad: 0
    };

    onViewItem = (item) => {
        console.log(item);
        if (item.answersUrl.endsWith('.doc') || item.answersUrl.endsWith('.docx')) {
            window.open(`https://docs.google.com/viewerng/viewer?url=${item.answersUrl}`, '_blank')
        } else {
            window.open(item.answersUrl, '_blank')
        }
    };

    render() {
        console.log(this.props.location.state);
        let state = this.props.location.state;
        return (
            <div>
                <Header/>
                <main ref="main" className={"viewPaper"}>
                    <div className="backBtnHolder">
                        <button className={"home-btn"}
                                onClick={() => window.history.back()}>
                            <i className="icofont-long-arrow-left"/>
                            {language[lang].BackToTour}
                        </button>
                    </div>
                    <div className="trapezoid "></div>

                    <br/>
                    <Container>

                        {state.teacherComments !== null && state.marks !== 0 ?
                            <Row style={{backgroundColor: '#b9d4d5', padding: '10px', borderRadius: '10px'}}>
                                <Col sm={6} md={6} lg={6}>
                                    <h5 style={{color: 'black'}}>Teacher's Comment : {state.teacherComments}</h5>
                                    <h5 style={{color: 'black'}}>Your Marks : {state.marks}</h5>
                                </Col>
                            </Row> :
                            <Row style={{backgroundColor: '#b9d4d5', padding: '10px', borderRadius: '10px'}}>
                                <Col sm={6} md={6} lg={6}>
                                    <h5 style={{color: 'black'}}>The teacher has not yet checked your question paper. Please wait!</h5>
                                </Col>
                            </Row>
                        }
                        <br/>
                        <Row className='answerSheet'>
                            {
                                state.quizWrittenAnswer.map((file, index) => {
                                    return (
                                        <Col key={index} sm={12} md={4} lg={4} onClick={() => this.onViewItem(file)}>

                                            <Card style={{borderWidth: '2px', borderRadius: '10px',cursor:'pointer'}}>
                                                <CardBody>
                                                    <div>
                                                        {file.answersUrl.endsWith('.jpeg') ?
                                                            <p><img src={file.answersUrl} alt={"."}
                                                                    className={"answer-img"}/></p> :
                                                            <img
                                                                src={pdfView}
                                                                alt={"."}
                                                                className={"answer-img"}/>
                                                        }
                                                    </div>

                                                    <p style={{textAlign: "center", marginTop: '5px',fontWeight:900,cursor:'pointer'}}><strong>View
                                                        Answer</strong></p>
                                                </CardBody>
                                            </Card>

                                        </Col>
                                    )
                                })
                            }


                            {/*<Col className={"pdf-wrapper"} style={{width: '100%', padding: '10px'}} sm={12} md={6}*/}
                            {/*     lg={6}>*/}
                            {/*    <p style={{paddingBottom: '2%'}}>Question Paper</p>*/}
                            {/*    <iframe key={this.state.randomLoad} className="fullScreen"*/}
                            {/*            src={'https://docs.google.com/gview?embedded=true&url=' + state.questionPaperUrl}/>*/}

                            {/*</Col>*/}
                            {/*<Col style={{width: '100%', padding: '10px'}} sm={12} md={6} lg={6}>*/}

                            {/*    <p style={{paddingBottom: '2%'}}>Answers you given</p>*/}
                            {/*    {state.quizWrittenAnswer.map((body, index) => (*/}


                            {/*            <Card style={{padding: '10px', margin: '5px'}}>*/}
                            {/*                <a href={body.answersUrl} target='_blank'>{index + 1}. Click to See Your*/}
                            {/*                    Answer </a>*/}
                            {/*            </Card>*/}

                            {/*        )*/}
                            {/*    )}*/}

                            {/*</Col>*/}


                        </Row>

                    </Container>


                </main>
            </div>
        )
    }

}

export default getComment;